import { Directive, HostListener, Optional } from '@angular/core';
import { AuthService, Labels, Permissions, ProjectMetaData, Tracking } from '@sew/ui-components';
import {
    HeaderConfigService,
    HeaderLoginService,
    OsApiAuthService,
    TrackingService,
    User,
} from '../../services/public-services';

@Directive({
    selector: '[oscHeaderEvents]',
})
export class HeaderEventsDirective {
    public constructor(
        private configService: HeaderConfigService,
        private loginService: HeaderLoginService,
        private authService: OsApiAuthService,
        @Optional() private trackingService: TrackingService
    ) {}

    private getEventDetail<T>(event: Event): T {
        return (event as globalThis.CustomEvent<T>).detail;
    }

    @HostListener('languageSwitch', ['$event'])
    public languageSwitch(event: Event): void {
        this.configService.setLanguage(this.getEventDetail<string>(event));
    }

    @HostListener('countryShort', ['$event'])
    public countryShort(event: Event) {
        this.configService.setCountryShort(this.getEventDetail<string>(event));
    }

    @HostListener('cmsProject', ['$event'])
    public cmsProject(event: Event) {
        this.configService.setCmsProject(this.getEventDetail<string>(event));
    }

    @HostListener('userChange', ['$event'])
    public userChange(event: Event) {
        this.loginService.setUser(this.getEventDetail<User>(event));
    }

    @HostListener('initComplete')
    public initComplete() {
        this.configService.setInitComplete();
    }

    @HostListener('labelsChange', ['$event'])
    public labelsChange(event: Event) {
        this.configService.setLabels(this.getEventDetail<Labels>(event));
    }

    @HostListener('projectMetaDataChange', ['$event'])
    public projectMetaDataChange(event: Event) {
        this.configService.setProjectMetaData(this.getEventDetail<ProjectMetaData>(event));
    }

    @HostListener('permissionChange', ['$event'])
    public userPermissionChange(event: Event) {
        this.configService.setPermissions(this.getEventDetail<Permissions>(event));
    }

    @HostListener('getTrackingService', ['$event'])
    public getTrackingService(event: Event) {
        if (this.trackingService !== null) {
            this.trackingService.setTracker(this.getEventDetail<Tracking>(event));
        }
    }

    @HostListener('authInstance', ['$event'])
    public async getAuthService(event: Event) {
        this.authService.setAuth(this.getEventDetail<AuthService>(event));
    }
}
